import React, { ReactNode, useState } from "react";

import cn from "classnames";
import QRCode from "react-qr-code";

import copySVG from "../../../../assets/copy.svg";
import { useIsMobile } from "../../hooks/useIsMobile";
import styles from "../../MultifactorAuth.module.css";
import { InformationBanner } from "../InformationBanner/InformationBanner";
import { SetupStep } from "../SetupStep/SetupStep";

export const SetupInstructions = ({
  setupUri,
  account,
  setupKey,
  children,
}: {
  setupUri: string;
  account: string;
  setupKey: string;
  children: ReactNode;
}) => {
  const { isMobile } = useIsMobile();
  const [shouldUseQRCode, setShouldUseQRCode] = useState<boolean>(!isMobile);

  const QRCodeOption = () => {
    return (
      <>
        <QRCode
          value={setupUri}
          bgColor={"rgba(255,255,255,0)"}
          className={styles.qrCode}
        />
        <p className={styles.qrCodeOtherOption}>
          Can’t scan the QR code?{" "}
          <button
            className={styles.inlineButton}
            onClick={() => setShouldUseQRCode(!shouldUseQRCode)}
          >
            Enter a setup key instead
          </button>
        </p>
      </>
    );
  };

  const SetupKeyOption = () => {
    return (
      <>
        <div className={styles.setupKeyTable}>
          <div className={styles.setupKeyTableRow}>
            <div className={styles.setupKeyTableHeader}>Account Email</div>
            <div className={styles.setupKeyTableBody}>{account}</div>
          </div>
          <button
            className={styles.copyButton}
            onClick={() => navigator.clipboard.writeText(account)}
          >
            Copy <img src={copySVG} className={styles.copySVG} alt="" />
          </button>
          <div className={styles.setupKeyTableRow}>
            <div className={styles.setupKeyTableHeader}>Setup Key</div>
            <div className={styles.setupKeyTableBody}>{setupKey}</div>
          </div>
          <button
            className={styles.copyButton}
            onClick={() => navigator.clipboard.writeText(setupKey)}
          >
            Copy <img src={copySVG} className={styles.copySVG} alt="" />
          </button>
        </div>
        <button
          className={cn(styles.inlineButton, styles.qrCodeOtherOption)}
          onClick={() => setShouldUseQRCode(!shouldUseQRCode)}
        >
          Scan a QR code instead
        </button>
      </>
    );
  };

  return (
    <>
      <h2 className={styles.headlineMedium}>Set up security</h2>
      <SetupStep
        stepNumber={1}
        stepText="Open your authenticator app"
      ></SetupStep>
      <InformationBanner type="notice">
        <b>Don’t have an “authenticator app?”</b> - We’d recommend downloading{" "}
        <a
          href="https://googleauthenticator.net/"
          target="blank"
          rel="nofollow"
          className={styles.link}
        >
          Google Authenticator
        </a>{" "}
        or{" "}
        <a
          href="https://www.microsoft.com/en-us/security/mobile-authenticator-app"
          target="blank"
          rel="nofollow"
          className={styles.link}
        >
          Microsoft Authenticator
        </a>
        . It doesn’t cost a penny and you can use them to add extra security to
        your other online accounts.
      </InformationBanner>
      <SetupStep
        stepNumber={2}
        stepText={
          isMobile
            ? "Enter these details into your authenticator app."
            : "Scan the QR code with your authenticator app"
        }
        stepSubtitle="This will add your iwocaPay account to your authenticator app"
      >
        <div className={styles.informationBox}>
          {shouldUseQRCode ? <QRCodeOption /> : <SetupKeyOption />}
        </div>
      </SetupStep>
      {children}
    </>
  );
};
